class ListGroup {

  constructor(node) {
    this.rootElement = node;
    this.buttonElement = this.rootElement.querySelector('.c-list-group-collapse-trigger');
    this.contentElement = this.buttonElement.closest('.c-list-group').querySelector('.c-list-group__container');
    this.buttonElement.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick() {
    this.toggle(!this.open);
  }

  toggle(open) {
    if (open === this.open) {
      return;
    }

    this.open = open;
    this.buttonElement.setAttribute('aria-expanded', open);
    if (this.contentElement.classList.contains('is-collapsed')) {
      this.contentElement.classList.remove('is-collapsed');
      this.buttonElement.classList.remove('bi-chevron-down');
      this.buttonElement.classList.add('bi-chevron-up');
    } else {
      this.contentElement.classList.add('is-collapsed');
      this.buttonElement.classList.add('bi-chevron-down');
      this.buttonElement.classList.remove('bi-chevron-up');
    }
  }

  open() {
    this.toggle(true);
  }

  close() {
    this.toggle(false);
  }
}

const collapsibleListGroups = document.querySelectorAll('.c-list-group--collapsible');
collapsibleListGroups.forEach((collapsibleListGroup) => {
  new ListGroup(collapsibleListGroup);
});
